<!--  -->
<template>
  <div class="log-page section-main__warp maintenance">
    <ioc-table ref="crud" :data="tableData" :option="option" :page="page" @search-change="query" @search-reset="reset"
      @size-change="sizeChange" @current-change="pageChange">
      <template #menuLeft>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleEdit('add')">新增</el-button>
        <!-- <el-button>导出</el-button> -->
      </template>
      <template slot="search_areaName" slot-scope="scope">
        <el-select v-model="scope.row.areaName" placeholder="请选择">
          <el-option v-for="item in locationOption" :key="item.value" :label="item.label" :value="item.label">
          </el-option>
        </el-select>
      </template>
      <template slot="search_repairDate" slot-scope="scope">
        <el-date-picker v-model="scope.row.time" type="daterange" range-separator="至" value-format="yyyy-MM-dd"
          start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-tooltip class="item" effect="dark" content="详情" placement="top" popper-class="tooltip-draw">
          <!-- <el-button type="text" icon="iconfont icon-Detail" @click="handleEdit('view', scope.row)"></el-button> -->
          <el-button type="text" icon="iconfont icon-Detail" @click="handleDetail(scope.row)"></el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="修改" placement="top" popper-class="tooltip-draw">
          <el-button type="text" icon="iconfont icon-xiugai" @click="handleEdit('edit', scope.row)"></el-button>
        </el-tooltip><el-tooltip class="item" effect="dark" content="删除" placement="top" popper-class="tooltip-draw">
          <el-button type="text" icon="iconfont icon-shanchu" @click="handleDelete(scope.row, scope.index)"></el-button>
        </el-tooltip>
      </template>
    </ioc-table>
    <el-dialog title="选择区域" :visible.sync="areaDialog">
      <el-tree style="height: 200px" :data="areaTree" :props="areaProps" @node-click="handleNodeClick"></el-tree>
      <div slot="footer">
        <el-button @click="handleCancelArea">取消</el-button>
        <el-button type="primary" @click="handleSelectArea"> 确定</el-button>
      </div>
    </el-dialog>
    <app-panel :isExpand="dialogVisible" :width="480" @cancel="handleCancel" :title="dialogTitle[type]">
      <el-form :model="formData" :rules="formRules" label-width="110px" label-suffix=":" ref="addForm">
        <el-form-item label="位置选择" prop="areaName">
          <div class="flex-row">
            <el-input v-model="formData.areaName" :disabled="true"></el-input>
            <span @click="handleOpenSelect"
              style=" color: rgb(64, 122, 238);cursor: pointer;width: 50px;text-align: center;">选择</span>
          </div>
        </el-form-item>
        <el-form-item label="设备名称" prop="deviceName">
          <el-input v-model="formData.deviceName" placeholder="请输入设备名称"></el-input>
          <!-- <el-select v-model="formData.deviceName">
            <el-option v-for="item in deviceList" :key="item.deviceId" :label="item.deviceName":value="item.deviceId"></el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="设备型号" prop="deviceVersion">
          <el-input v-model="formData.deviceVersion" placeholder="请输入设备型号"></el-input>
        </el-form-item>
        <el-form-item label="保养内容" prop="repairContent">
          <el-input type="textarea" v-model="formData.repairContent"></el-input>
        </el-form-item>
        <el-form-item label="保养人" prop="repairPersonnelCode">
          <el-select v-model="formData.repairPersonnelCode" @change="handlePersonChange">
            <el-option v-for="item in personList" :key="item.personnelCode" :label="item.name"
              :value="item.personnelCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="维修时间" prop="repairTime">
          <el-date-picker v-model="formData.repairTime" type="date" value-format="yyyy-MM-dd" placeholder="选择维修日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="维保图片" prop="repairImages">
          <div style="max-height: 380px; overflow-y: auto;">
            <el-upload ref="addUpload" action="/common/file/batchFileload.json" list-type="picture-card"
              accept="image/png, image/jpg, image/jpeg" name="files" :on-success="onSuccessFile"
              :file-list="fileListUpdate" :on-remove="handleRemove">
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="handleSubmit" v-if="type !== 'view'">确认</el-button>
      </div>
    </app-panel>
    <app-panel :isExpand="dialogDetailVisible" :width="480" @cancel="handleDetailCancel" title="维保记录详情">
      <el-form :model="formDetailData" label-width="110px" label-suffix=":">
        <el-form-item label="位置选择" prop="areaName">
          <div>{{ formDetailData.areaName }}</div>
        </el-form-item>
        <el-form-item label="设备名称" prop="deviceName">
          <div>{{ formDetailData.deviceName }}</div>
        </el-form-item>
        <el-form-item label="设备型号" prop="deviceVersion">
          <div>{{ formDetailData.deviceVersion }}</div>
        </el-form-item>
        <el-form-item label="保养内容" prop="repairContent">
          <div>{{ formDetailData.repairContent }}</div>
        </el-form-item>
        <el-form-item label="保养人" prop="repairPersonnelName">
          <div>{{ formDetailData.repairPersonnelName }}</div>
        </el-form-item>
        <el-form-item label="维修时间" prop="repairTime">
          <div>{{ formDetailData.repairTime }}</div>
        </el-form-item>
        <el-form-item label="维保图片" prop="">
          <div style="display: flex; flex-wrap: wrap; max-height: 350px; overflow-y: auto;">
            <div v-for="item in formDetailData.repairImagesArr" :key="item" style="margin: 0 10px 10px 0;">
              <el-image style="width: 148px; height: 148px" :src="getImgPath(item)"
                :preview-src-list="[getImgPath(item)]"></el-image>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="handleDetailCancel">关闭</el-button>
      </div>
    </app-panel>
  </div>
</template>

<script>
import appPanel from "@src/components/business/app-panel/index.vue";

import tableOption from "../const/maintenanceConfig";
import utils from "@src/common/utils";
import { api } from "../api/api";
export default {
  components: {
    appPanel,
  },
  data() {
    return {
      areaProps: {
        children: "children",
        label: "name",
      },
      areaDialog: false,
      dialogTitle: { add: "新增维保记录", edit: "修改维保记录", view: "详情" },
      dialogVisible: false,
      formData: {
        repairPersonnelCode: "",
        repairPersonnelName: "",
        deviceName: "",
        deviceVersion: "",
        repairContent: "",
        repairTime: "",
        areaName: "",
        areaCode: "",
        repairImages: ""
      },
      formRules: {
        areaName: [{ required: true, message: "请选择位置", trigger: "blur" }],
        deviceName: [
          { required: true, message: "请选择设备名称", trigger: "blur" },
        ],
        deviceVersion: [
          { required: false, message: "请选择设备型号", trigger: "blur" },
        ],
      },
      page: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      queryParams: {},
      option: tableOption(),
      tableData: [
        {
          location: "一号库",
        },
      ],
      deviceList: [],
      personList: [],
      areaTree: [],
      type: "add",
      locationOption: [],
      formDetailData: {
        areaName: "",
        deviceName: "",
        deviceVersion: "",
        repairContent: "",
        repairPersonnelName: "",
        repairTime: "",
        repairImagesArr: []
      },
      dialogDetailVisible: false,
      fileListUpdate: []
    };
  },
  mounted() {
    this.queryList();
    // this.queryDeviceList();
    this.queryPersonList();
    this.queryLocationOption();
  },
  methods: {
    handleDetail(row) {
      this.formDetailData.areaName = row.areaName
      this.formDetailData.deviceName = row.deviceName
      this.formDetailData.deviceVersion = row.deviceVersion
      this.formDetailData.repairContent = row.repairContent
      this.formDetailData.repairPersonnelName = row.repairPersonnelName
      this.formDetailData.repairTime = row.repairTime
      this.formDetailData.repairImagesArr = row.repairImages ? row.repairImages.split(',') : []
      this.dialogDetailVisible = true
    },
    handleDetailCancel() {
      this.dialogDetailVisible = false
    },
    getImgPath(item) {
      return item ? utils.Bus.imgPath(item) : "";
    },
    onSuccessFile(res, file, fileList) {
      let imgCodeArr = []
      let fileListArr = fileList;
      for (let i = 0; i < fileListArr.length; i++) {
        if (fileListArr[i].response && fileListArr[i].response.success) {
          imgCodeArr.push(fileListArr[i].response.returnObj[0].fileId)
        }
        if ((fileListArr[i].url).indexOf('fileCode') != -1) (
          imgCodeArr.push(fileListArr[i].name)
        )
      }
      this.formData.repairImages = imgCodeArr.join(',')
    },
    handleRemove(file, fileList) {
      let imgCodeArr = []
      let fileListArr = fileList;
      for (let i = 0; i < fileListArr.length; i++) {
        if (fileListArr[i].response && fileListArr[i].response.success) {
          imgCodeArr.push(fileListArr[i].response.returnObj[0].fileId)
        }
        if ((fileListArr[i].url).indexOf('fileCode') != -1) (
          imgCodeArr.push(fileListArr[i].name)
        )
      }
      this.formData.repairImages = imgCodeArr.join(',')
    },
    //查询区域
    queryLocationOption() {
      const userInfoCache = this.$store.getters.userInfo;
      let accountNumber = userInfoCache.account;
      let params = {
        accountNumber,
      };
      this.locationOption = []
      this.$fetch(api.queryAssociationalDeviceTree, params).then((res) => {
        if (!res.success) {
          this.$message(res.msgContent);
        }
        const locationArr = res.returnObj
        for (let i = 0; i < locationArr.length; i++) {
          this.locationOption.push({
            label: locationArr[i].areaDevGroupName,
            value: locationArr[i].areaDevGroupCode
          })
          if (locationArr[i].childrens && locationArr[i].childrens.length > 0) {
            for (let j = 0; j < locationArr[i].childrens.length; j++) {
              this.locationOption.push({
                label: locationArr[i].childrens[j].areaDevGroupName,
                value: locationArr[i].childrens[j].areaDevGroupCode
              })
            }
          }
        }
      });
    },
    reset() {
      this.queryParams = {};
      this.page.pageSize = 10;
      this.queryList();
    },
    query(data) {
      let items = {};
      if (data.time && data.time.length > 0) {
        items.repairStartTime = data.time[0];
        items.repairEndTime = data.time[1];
      }
      this.queryParams = { ...data, ...items };
      this.queryList();
    },
    handleNodeClick(data) {
      this.formData.areaName = data.name;
      this.formData.areaCode = data.id;
    },
    handleOpenSelect() {
      this.areaDialog = true;
      this.queryLocationTree();
    },
    handleSelectArea() {
      if (!this.formData.areaName) {
        this.$message.warning("请选择区域");
        return;
      }
      this.areaDialog = false;
    },
    handlePersonChange(data) {
      this.formData.repairPersonnelName = this.personList.filter(
        (item) => data == item.personnelCode
      )[0].name;
    },
    handleCancelArea() {
      this.areaDialog = false;
      this.formData.areaCode = "";
    },
    handleCancel() {
      // this.$refs.addForm.resetFields();
      this.formData = {};
      this.fileListUpdate = []
      this.dialogVisible = false
    },
    handleSubmit() {
      this.$refs.addForm.validate((val) => {
        if (val) {
          let params = { ...this.formData };
          let url =
            this.type === "add"
              ? api.addDeviceRepairRecord
              : api.updateDeviceRepairRecord;
          this.$fetch(url, params).then((res) => {
            if (!res.success) {
              this.$message(res.msgContent);
            } else {
              this.handleCancel();
              this.$message.success(
                this.type === "add" ? "新增成功" : "修改成功"
              );
              this.queryList();
            }
          });
        }
      });
    },
    queryList() {
      let params = { ...this.page, ...this.queryParams };
      this.$fetch(api.queryDeviceRepairRecordList, params).then((res) => {
        if (!res.success) {
          this.$message(res.msgContent);
        }
        this.tableData = res.returnObj.list;
        this.page.total = res.returnObj.total;
      });
    },
    //查询区域
    queryLocationTree() {
      const userInfoCache = this.$store.getters.userInfo;
      let accountNumber = userInfoCache.account;

      let params = {
        accountNumber,
      };
      this.$fetch(api.queryAssociationalDeviceTree, params).then((res) => {
        if (!res.success) {
          this.$message(res.msgContent);
        }
        this.areaTree = this.menusDataPro(res.returnObj);
      });
    },
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.id = item.areaDevGroupCode;
          entity.name = item.areaDevGroupName;
          // entity.appointmentCarNotifyFlag = item.appointmentCarNotifyFlag
          // entity.appointmentNoCarNotifyFlag = item.appointmentNoCarNotifyFlag
          // entity.leaderCode = item.securityWorkGroupLeader
          // entity.leaderName = item.leaderName
          entity.parentCode = item.parentCode;
          //   entity.areaDevGroupCodeList = item.workOrderWorkGroupChildren;
          entity.isLeaf = !item.hasLeaf || !item.childrens;
          if (item.childrens) {
            entity.children = self.menusDataPro(item.childrens);
          }
          result.push(entity);
        });
        return result;
      }
    },
    //查询员工
    queryPersonList() {
      this.$fetch(api.queryPersonListApi, {
        // departmentCodeList: ["20230707000001"],
        pageNum: 1,
        pageSize: 10,
        personnelType: 1,
      }).then((res) => {
        if (!res.success) {
          this.$message(res.msgContent);
        }
        this.personList = res.returnObj.list;
      });
    },
    //风机设备
    queryDeviceList() {
      this.$fetch(api.queryDeviceListByType, { deviceType: "25" }).then(
        (res) => {
          if (!res.success) {
            this.$message.error(res.msgContent);
          }
          this.deviceList = [
            { deviceId: "001", deviceName: "排风机	P-1-1" },
            { deviceId: "002", deviceName: "排风机	P-2-1" },
          ];
        }
      );
    },
    sizeChange(pageSize) {
      this.page.pageNo = 1;
      this.page.pageSize = pageSize;
      this.queryList();
    },
    pageChange(pageNo) {
      this.page.pageNo = pageNo;
      this.queryList();
    },
    handleEdit(type, row) {
      this.fileListUpdate = []
      this.dialogVisible = true;
      this.type = type;
      if (type == "edit") {
        this.formData = row;
        let imgArr = row.repairImages ? row.repairImages.split(',') : []
        for (let i = 0; i < imgArr.length; i++) {
          this.fileListUpdate.push({
            name: imgArr[i],
            url: this.getImgPath(imgArr[i])
          })
        }
      }
    },
    handleDelete(row) {
      this.$confirm("提示", "确定删除该条记录吗?", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        let params = {
          repairCodeList: [row.repairCode],
        };
        this.$fetch(api.deleteDeviceRepairRecord, params).then((res) => {
          if (!res.success) {
            this.$message(res.msgContent);
          }
          this.$message.success("删除成功");
          this.queryList();
        })
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.imgFile {
  display: flex;
  position: relative;

  &:hover {
    .delete-icon {
      opacity: 1;
    }
  }

  .delete-icon {
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 140px;
    height: 140px;
    border-radius: 6px;
    opacity: 0;
    cursor: pointer;
    background-color: rgba($color: #000000, $alpha: 0.4);
    transition: all 0.2s;
    box-shadow: -1px -1px 5px #7367f0, 1px 1px 5px #7367f0;
  }
}
</style>

<style>
.maintenance .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.maintenance .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.maintenance .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 140px;
  height: 140px;
  line-height: 140px !important;
  text-align: center;
}

.maintenance .avatar {
  width: 140px;
  height: 140px;
  display: block;
  cursor: pointer;
}
</style>